import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({
    key: 'cia',
    storage: window.localStorage,
    reducer: state => ({
      app: {
        token: state.app.token,
        refreshToken: state.app.refreshToken,
      },
      user: {
        details: state.user.details,
        gdAccess: state.user.gdAccess,
        role: state.user.role,
      },
    }),
  })],
  strict: process.env.NODE_ENV !== 'production',
});
